import { c as _c } from "react/compiler-runtime";
import { ReactNode } from 'react';
import { Card, CardBody, Copyright } from '@personly/libs-widgets';
import BrandJumbotron from '@/components/brand-jumbotron';
interface Props {
  children: ReactNode;
  name: string;
}
const ErrorView = t0 => {
  const $ = _c(10);
  const {
    children,
    name
  } = t0;
  let t1;
  if ($[0] !== name) {
    t1 = <div><BrandJumbotron alt={name} /></div>;
    $[0] = name;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div>{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== name) {
    t3 = <div className="flex justify-center"><Copyright name={name} /></div>;
    $[4] = name;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="w-full flex sm:container justify-center px-3 mx-auto sm:px-0"><div className="w-full sm:w-3/5 lg:w-2/5"><Card shadow={true}><CardBody><div className="flex flex-col gap-3">{t1}{t2}{t3}</div></CardBody></Card></div></div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default ErrorView;